import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";


export const GraphContent = styled.div`
    width:80%;
    max-width: 300px;

    
    canvas{
        width:100% !important;
        height:unset !important;
        aspect-ratio: 1 / 1 !important;
    }
`;
